import { useEffect, useState } from 'react';

interface ElementSize {
  width: number | undefined;
  height: number | undefined;
}

function useElementSize(elementId: string): ElementSize {
  const [dimensions, setDimensions] = useState<ElementSize>({
    width: undefined,
    height: undefined,
  });

  useEffect(() => {
    const element = document.getElementById(elementId);

    if (element) {
      setDimensions({
        width: element.offsetWidth,
        height: element.offsetHeight,
      });
    }
  }, [elementId]);

  return dimensions;
}

export default useElementSize;
